// URL BASE
//export const BASE_URL_SERVER = "http://localhost:8080/ayacucho/api/";
export const BASE_URL_SERVER = process.env.REACT_APP_BASE_URL_SERVER;

//CONSTANTES DE VALIDACION DE FORMULARIOS
export const MAX_SIZE_IMAGE_BYTES = 1000000;

// LATITUDES Y LONGITUDES
export const LATITUD_AYACUCHO = -37.150133;
export const LONGITUD_AYACUCHO = -58.48414;

// API KEY GOOGLE MAPS
export const KEY_MAP = "AIzaSyBnnHpwCHxuiZ4GUKU1-g0vAeEcNNSipW4";

// IDENTIFICADORES DE SERVICIOS
export const SERVICE_EMERGENCY_ID = 2;
export const SERVICE_NOTICE_ID = 3;
export const SERVICE_REPORT_ID = 4;
export const SERVICE_RESERVATION_ID = 5;
export const SERVICE_EMERGENCY_NAME = "emergency";
export const SERVICE_NOTICE_NAME = "notice";
export const SERVICE_REPORT_NAME = "report";
export const SERVICE_RESERVATION_NAME = "reservation";

// URLS END POINTS
export const URL_AUTH = "auth/";
export const URL_NEWS = "notice/";
export const URL_CATEGORIES = "categories/";
export const URL_COVID = "covid/";
export const URL_ISOLATED = "isolated/";
export const URL_BUSINESS = "business/";
export const URL_USERS = "users/";
export const URL_SUBCATEGORIES = "subcategories/";
export const URL_SERVICES = "services/";
export const URL_ALL_SUBCATEGORIES = "subcategories/all";
export const URL_ROLES = "roles/";
export const URL_ON_DUTY = "onduty/";
export const URL_BINS = "bins/public/";
export const URL_PING = "/ping/";
export const URL_REPORTS = "report/";
export const URL_RESERVATION = "reservation/";
export const URL_EVENTS = "events/";
export const URL_SHIFT = "shifts";
export const URL_ATTENDEES = "attendees/";
export const URL_INFO = "info";
export const URL_MOBILITY_BETWEEN_DATES = "/getMobilityMetricBetween";
export const URL_MOBILITY_LAST_VISITS = "/lastVisitsBetween";
export const URL_TRACE = "trace";
export const URL_TRACE_USER_DATA = "/traceUserDate";
export const URL_TRACE_CONTACT_USER_DATA = "/traceContactUserDate";

export const FINAL_URL_AUTH = BASE_URL_SERVER + URL_AUTH;
export const FINAL_URL_CATEGORIES =
  BASE_URL_SERVER + URL_SERVICES + URL_NEWS + URL_CATEGORIES;
export const FINAL_URL_ALL_CATEGORIES =
  BASE_URL_SERVER + URL_SERVICES + URL_NEWS + URL_CATEGORIES + "all";
export const FINAL_URL_QUARENTINE = BASE_URL_SERVER + URL_COVID + URL_ISOLATED;
export const FINAL_URL_BUSINESS = BASE_URL_SERVER + URL_BUSINESS;
export const FINAL_URL_USERS = BASE_URL_SERVER + URL_USERS;
export const FINAL_URL_NOTICES = BASE_URL_SERVER + URL_SERVICES + URL_NEWS;
export const FINAL_URL_EMERGENCY =
  BASE_URL_SERVER + URL_SERVICES + SERVICE_EMERGENCY_NAME;
export const FINAL_URL_ROLES = FINAL_URL_USERS + URL_ROLES;
export const FINAL_URL_ON_DUTY = BASE_URL_SERVER + URL_BUSINESS + URL_ON_DUTY;
export const FINAL_URL_BINS = BASE_URL_SERVER + URL_BINS;
export const FINAL_URL_REPORTS = BASE_URL_SERVER + URL_SERVICES + URL_REPORTS;
export const FINAL_URL_RESERVATIONS =
  BASE_URL_SERVER + URL_SERVICES + URL_RESERVATION;
export const FINAL_URL_INFO = BASE_URL_SERVER + URL_INFO;
export const FINAL_URL_BETWEEN_DATES =
  FINAL_URL_INFO + URL_MOBILITY_BETWEEN_DATES;
export const FINAL_URL_VISITS_BETWEEN_DATES =
  BASE_URL_SERVER + URL_INFO + URL_MOBILITY_LAST_VISITS;
export const FINAL_URL_TRACE_USER_DATE =
  BASE_URL_SERVER + URL_TRACE + URL_TRACE_USER_DATA;
export const FINAL_URL_TRACE_CONTACT_USER_DATE =
  BASE_URL_SERVER + URL_TRACE + URL_TRACE_CONTACT_USER_DATA;

//RESPUESTAS SERVIDOR

export const RESPONSE_OK = 200;
export const RESPONSE_CREATED = 201;
export const RESPONSE_NO_CONTENT = 204;

//ROLES
export const ROLE_ADMIN_ID = 5000;
export const ROLE_POLICE_ADMIN_ID = 3001;
export const ROLE_PRESS_ADMIN_ID = 3501;
export const ROLE_HEALTH_ADMIN_ID = 3201;
export const ROLE_REPORTS_ADMIN_ID = 4001;
export const ROLE_EVENTS_ADMIN_ID = 4501;

//ROUTES
export const ROUTE_BUSINESS = "/business";
export const ROUTE_EMERGENCY = "/emergency";
export const ROUTE_NEWS = "/news";
export const ROUTE_COVID = "/covid";
export const ROUTE_REPORTS = "/reports";
export const ROUTE_EVENTS = "/reservation";
export const ROUTE_DASHBOARD = "/dashboard";

//CATEGORIAS NEGOCIOS
export const CATEGORY_PHARMACY = 6;

//ESTADOS SERVICIO DE REPORTES
export const REPORT_SERVICE_RECEPTION_CONFIRM = 1;
export const REPORT_SERVICE_ATTENDING = 2;
export const REPORT_SERVICE_FINISH = 3;
export const REPORT_SERVICE_DISMISS = 4;

// TIPO DE ERRORES
export const ERROR_TYPE_DATA = 1;
export const ERROR_TYPE_SERVER = 2;
